export default __webpack_public_path__ + "static/media/html.4a30634c.svg";